// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__B1zka","calendarButtons":"ClockData_calendarButtons__3nq43"};